var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import $ from 'jquery';
import { debounce } from 'helpful-decorators';
export default class OrderSummary {
    static $element = $('.js__order-summary');
    static $spinner = $('.js__order-summary-spinner');
    static $error = $('.js__order-summary-error');
    static $promotionCoupon = $('.js__order-summary-promotion-coupon');
    static $shippingMethod = $('.js__order-summary-shipping-method');
    static itemSelector = '.js__order-summary-item';
    static itemVariantSelector = '.js__order-summary-item-variant';
    static itembundleProductVariantSelector = '.js__order-summary-item-bundle-product-variant';
    static itemQuantitySelector = '.js__order-summary-item-quantity';
    static returnItemSelector = '.js__order-summary-return-item';
    static returnItemVariantSelector = '.js__order-summary-return-item-variant';
    static url = OrderSummary.$element.data('url');
    static request;
    static init() {
        if (!this.$element.length) {
            return;
        }
        this.trackChanges();
        this.updateOrderSummary();
    }
    static trackChanges() {
        this.$promotionCoupon.on('input', () => {
            this.updateOrderSummary();
        });
        this.$shippingMethod.on('change', () => {
            this.updateOrderSummary();
        });
        $(document).on('change', `${this.itemVariantSelector}, ${this.itembundleProductVariantSelector}, ${this.returnItemVariantSelector}`, () => {
            this.updateOrderSummary();
        });
        $(document).on('input', this.itemQuantitySelector, () => {
            this.updateOrderSummary();
        });
    }
    static updateOrderSummary() {
        const formData = this.getFormData();
        if (formData === null) {
            return;
        }
        if (this.request) {
            this.request.abort();
        }
        this.$spinner.show();
        this.request = $.post(this.url, formData, null, 'html')
            .done(response => {
            this.$error.hide();
            this.$element.html(response);
        })
            .fail(() => {
            this.$element.empty();
            this.$error.show();
        })
            .always(() => {
            this.$spinner.hide();
        });
    }
    static getFormData() {
        const promotionCoupon = this.$promotionCoupon.val();
        const shippingMethod = this.$shippingMethod.val();
        const hasShippingMethod = this.$shippingMethod.length !== 0;
        const items = $(this.itemSelector)
            .toArray()
            .map(item => {
            const $item = $(item);
            const bundleOrderItems = $item
                .find(this.itembundleProductVariantSelector)
                .toArray()
                .map(bundleProductVariant => ({ bundleProductVariant: $(bundleProductVariant).val() }));
            const variant = $item.find(this.itemVariantSelector).val();
            const $quantity = $item.find(this.itemQuantitySelector);
            const quantity = $quantity.val();
            return (variant || bundleOrderItems) && ($quantity.length ? quantity : true)
                ? {
                    ...(variant && { variant }),
                    ...(bundleOrderItems && { bundleOrderItems }),
                    ...(quantity && { quantity }),
                }
                : null;
        })
            .filter(item => item !== null);
        const tradeIns = $(this.returnItemSelector)
            .find(this.returnItemVariantSelector)
            .toArray()
            .map(item => {
            const $item = $(item);
            const returnDevice = $item.val();
            return returnDevice
                ? {
                    ...(returnDevice && { returnDevice }),
                }
                : null;
        })
            .filter(item => item !== null);
        return items.length && promotionCoupon && (!hasShippingMethod || shippingMethod)
            ? {
                items,
                promotionCoupon,
                ...(hasShippingMethod && { shippingMethod }),
                ...(tradeIns.length && { tradeIns }),
            }
            : null;
    }
}
__decorate([
    debounce(1000, { leading: true })
], OrderSummary, "updateOrderSummary", null);
